import type { ClipLibraryData } from '~/components/common/types'
import { getDefaultClipLibraryData } from '~/components/common/types'

export const useClipLibraryStore = defineStore('clipLibrary', {
  state: () => ({
    isContentLoaded: false,
    isRouteMove: false,
    expire: '',
    pagePath: '',
    positionY: 0,
    lastFullPath: '',
    isUseScrollRestore: false,
    clipLibraryData: getDefaultClipLibraryData(),
    facilityId: '',
  }),

  getters: {
  },

  actions: {
    async fetchItem ({ facilityId }) {
      const url = useRuntimeConfig().public.externalApiUrl + 'clip_library/' + facilityId
      console.log('clipLibrary.url', url)

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache',
          },
        })

        if (!response.ok) {
          throw new Error('response error')
        }

        const data = await response.json()
        const clipLibraryData = data
        console.log('clipLibrary.clipData', clipLibraryData)
        this.clipLibraryData = clipLibraryData
        this.facilityId = facilityId
      } catch (error) {
        console.error('Fetch error:', error)
        navigateTo({ path: '/error' })
      }
    },
  },
})
